export const AppRouteConstant = {
  CHANGE_HISTORY_ROUTE: '/history'
};
